import { Pane, Polyline } from 'react-leaflet';
import { DeviceNodePolyline } from '@features/components/LocationTracking/types';
import { SweepingPolyline } from '../SweepingPolyline/SweepingPolyline';

const ACTIVE_BASE_COLOR = '#E78521';
const ACTIVE_SWEEP_COLOR = '#FFD27A';
const COMPLETED_PATH_OPTIONS = { color: '#A25D17', weight: 5 } as const;
const TRACKED_PANE_STYLE = { zIndex: 450 } as const;

type TrackingPolylineProps = DeviceNodePolyline;

export const TrackingPolyline = ({ id, plannedPositions, trackedPositions, isComplete }: TrackingPolylineProps) => {
  if (isComplete) {
    const positions = trackedPositions.length > 0 ? trackedPositions : plannedPositions;

    return positions.length > 1 ? (
      <Pane name={`tracked-pane-${id}`} style={TRACKED_PANE_STYLE}>
        <Polyline key={`completed-${id}`} positions={positions} pathOptions={COMPLETED_PATH_OPTIONS} />
      </Pane>
    ) : null;
  }

  const connectedPlannedPositions =
    trackedPositions.length > 0 && plannedPositions.length > 0
      ? [trackedPositions[trackedPositions.length - 1], ...plannedPositions]
      : plannedPositions;

  return (
    <>
      {connectedPlannedPositions.length > 1 && (
        <SweepingPolyline
          key={`planned-${id}`}
          positions={connectedPlannedPositions}
          baseColor={ACTIVE_BASE_COLOR}
          sweepColor={ACTIVE_SWEEP_COLOR}
          minSegments={150}
        />
      )}
      {trackedPositions.length > 1 && (
        <Pane name={`tracked-pane-${id}`} style={TRACKED_PANE_STYLE}>
          <Polyline key={`tracked-${id}`} positions={trackedPositions} pathOptions={COMPLETED_PATH_OPTIONS} />
        </Pane>
      )}
    </>
  );
};
